// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3JLTr","label":"Radio_label__2zscv","checkMark":"Radio_checkMark__2Bieh","disabled":"Radio_disabled__1eoM_"};